module.exports = __webpack_public_path__ + "img/herb-lemongrass-190x100.aea28521.jpg";